module.exports = __webpack_public_path__ + "static/media/analytics.a34830cd.svg";